<template>

  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
      <div class="panel-heading">
        Payment Reports
      </div>
      <div class="panel-body">
        <div class="table-responsive">
          <vue-good-table
            :columns="columns"
            :rows="[]"
            :paginate="true"
            :globalSearch="true"
            :lineNumbers="true"
            styleClass="table table-responsive table-bordered table-stripped"
          >
            <template slot="table-row" slot-scope="props">
            </template>
          </vue-good-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          label: 'Booking Id',
          field: ''
        },
        {
          label: 'Payment Mode',
          field: ''
        },
        {
          label: 'Amount',
          field: ''
        },
        {
          label: 'Date of Payment',
          field: ''
        },
        {
          label: 'Action',
          value: ''
        }
      ]
    }
  }
}
</script>

<style>

</style>
